// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Ho-z","slideIn":"Io-z"};